export default {
    props: {
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        }, 

        from: {
            type: Number,
            default: undefined,
            kComposite: 'from'
        }, 

        to: {
            type: Number,
            default: undefined,
            kComposite: 'to'
        }
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/ColorsProps.js